import React, { memo } from 'react';
import { Reaction } from '../../types';
import { AnimatedReaction, AnimatedReactionInner, ParticipantNameBubble, ReactionEmoji } from './view';
import { LottieReaction } from './LottieReaction';
import { LOTTIE_ANIMATIONS } from './lottie/associations';

export interface AnimatedReactionItemProps {
    reaction: Reaction;
    offsetX: number;
    delay: number;
    displayName: string;
    effectiveParticipantId: string;
    isFading?: boolean;
}

export const AnimatedReactionItem = memo<AnimatedReactionItemProps>(
    ({ reaction, offsetX, delay, displayName, effectiveParticipantId, isFading = false }) => {
        const lottieFile = LOTTIE_ANIMATIONS[reaction.type];

        if (!lottieFile) {
            console.warn(`[AnimatedReaction] No Lottie file for reaction type: ${reaction.type}`);
        }

        return (
            <AnimatedReaction $offsetX={offsetX} $isFading={isFading}>
                <AnimatedReactionInner $delay={delay}>
                    {lottieFile ? (
                        <LottieReaction animationFile={lottieFile} />
                    ) : (
                        <ReactionEmoji>{reaction.type}</ReactionEmoji>
                    )}
                    <ParticipantNameBubble
                        participantId={effectiveParticipantId}
                        data-color-identity={reaction.colorIdentity ?? ''}
                        data-participant-id={reaction.participantId}
                        data-reaction-id={reaction.id}
                    >
                        {displayName}
                    </ParticipantNameBubble>
                </AnimatedReactionInner>
            </AnimatedReaction>
        );
    },
    (prevProps, nextProps) => {
        return prevProps.reaction.id === nextProps.reaction.id && prevProps.isFading === nextProps.isFading;
    },
);

AnimatedReactionItem.displayName = 'AnimatedReactionItem';
